import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Bold, HelperText } from '@components/Styled';
import { DataContainer, TotalContainer, TotalTitle } from './SummaryCard.style';
const Total = ({ children }) => (_jsx(TotalContainer, { children: children }));
const TotalLabel = ({ children, helper }) => (_jsx("div", { children: _jsxs(DataContainer, { children: [_jsx(Bold, { children: children }), helper && (_jsx(HelperText, { children: helper }))] }) }));
const TotalAmount = ({ children, color, helper }) => (_jsx("div", { children: _jsxs(DataContainer, { children: [children && (_jsx(TotalTitle, { style: { color }, children: children })), helper && (_jsx(HelperText, { children: helper }))] }) }));
Total.TotalLabel = TotalLabel;
Total.TotalAmount = TotalAmount;
export default Total;
